import React from "react";
import CornerCell from "./CornerCell";
import ColumnHeader from "./ColumnHeader";

/**
 * GridHeader
 * The table's `<thead>` — the corner cell plus one ColumnHeader per
 * visible column.  Sticky-top positioning is handled in CSS; sticky-left
 * for frozen columns is added inline based on `frozenColOffsets`.
 */
const GridHeader = React.forwardRef(function GridHeader({
  maxCols, colWidths, hiddenCols,
  frozenCols, frozenColOffsets,
  selectionType, normalizedSelection,
  isLastVisibleBeforeHidden,
  filters, activeFilterCol, normalizedRows,
  onToggleFilter, onApplyFilter, onCloseFilter,
  onSelectColumn, onHeaderContextMenu, onStartResize,
}, ref) {
  return (
    <thead ref={ref}>
      <tr>
        <CornerCell />
        {Array.from({ length: maxCols }).map((_, colIndex) => {
          if (hiddenCols.has(colIndex)) return null;
          const isFrozenCol = colIndex < frozenCols;
          const className = [
            isLastVisibleBeforeHidden(colIndex) ? "hidden-col-after" : "",
            selectionType === "col" && colIndex >= normalizedSelection.c1 && colIndex <= normalizedSelection.c2
              ? "selected-header" : "",
            colIndex === frozenCols - 1 ? "freeze-col-border" : "",
          ].join(" ").trim();

          const style = {
            minWidth: `${colWidths[colIndex]}px`,
            width: `${colWidths[colIndex]}px`,
            ...(isFrozenCol
              ? { position: "sticky", left: `${frozenColOffsets[colIndex] || 0}px`, zIndex: 25 }
              : {}),
          };

          return (
            <ColumnHeader
              key={`col-${colIndex}`}
              colIndex={colIndex}
              colWidth={colWidths[colIndex]}
              className={className}
              style={style}
              isFiltered={Boolean(filters[colIndex])}
              isFilterMenuOpen={activeFilterCol === colIndex}
              filterRows={normalizedRows}
              currentFilter={filters[colIndex]}
              onToggleFilter={onToggleFilter}
              onApplyFilter={onApplyFilter}
              onCloseFilter={onCloseFilter}
              onClick={(e) => onSelectColumn(colIndex, e)}
              onContextMenu={(e) => onHeaderContextMenu(e, "col", colIndex)}
              onStartResize={onStartResize}
            />
          );
        })}
      </tr>
    </thead>
  );
});

export default React.memo(GridHeader);
